import { type InitDomainDto } from 'app/components/domains/types';
import { type InitParticipantDto } from 'app/components/participants/types';
import { type InitValidatorDto } from 'app/components/validators/types';
import { type InitRemoteDomainDto } from 'app/components/remote-domains/types';
import { type ParticipantDto, MemoryEnum, DomainDto, RemoteDomainDto, ValidatorDto } from 'data';

export const unitSplitter = (obj?: { value: string; unit: string }): string => {
  if (!obj) return '';
  return `${obj.value}${obj.unit}`;
};

export const prepareResourcesToRequest = (
  resources:
    | InitParticipantDto['resources']
    | InitDomainDto['resources']
    | InitRemoteDomainDto['resources']
    | InitValidatorDto['clusterConfig']['appInfoValidator']['resources']
    | InitValidatorDto['participant']['resources']
    | InitValidatorDto['clusterConfig']['appInfoCantonNameService']['resources']
    | InitValidatorDto['clusterConfig']['appInfoWallet']['resources'],
):
  | ParticipantDto['resources']
  | InitDomainDto['resources']
  | InitRemoteDomainDto['resources']
  | InitValidatorDto['clusterConfig']['appInfoValidator']['resources']
  | InitValidatorDto['participant']['resources']
  | InitValidatorDto['clusterConfig']['appInfoWallet']['resources'] => {
  const { memoryLimit, memoryRequested } = resources;

  return {
    ...resources,
    memoryLimit: unitSplitter(memoryLimit),
    memoryRequested: unitSplitter(memoryRequested),
  };
};

export const prepareResourcesToForm = (
  resources:
    | ParticipantDto['resources']
    | DomainDto['resources']
    | RemoteDomainDto['resources']
    | ValidatorDto['clusterConfig']['appInfoValidator']['resources'],
):
  | InitParticipantDto['resources']
  | InitDomainDto['resources']
  | InitRemoteDomainDto['resources']
  | InitValidatorDto['clusterConfig']['appInfoValidator']['resources']
  | undefined => {
  if (!resources) return resources;

  const regExp = /[a-zA-Z]/g;

  return {
    ...resources,
    memoryLimit: {
      value: String(parseFloat(resources.memoryLimit)),
      unit: resources.memoryLimit.match(regExp)?.join('') as MemoryEnum,
    },
    memoryRequested: {
      value: String(parseFloat(resources.memoryRequested)),
      unit: resources.memoryRequested.match(regExp)?.join('') as MemoryEnum,
    },
  };
};
